export default "__VITE_ASSET__C$xdnZ$E__"